<div (clickOutside)="shouldClose.emit()" [delayClickOutsideInit]="true">
  <div class="calendar">
    <div class="calendar-header">
      <div class="active-year">{{ activeYear }}</div>
      <div class="calendar-controls">
        <wm-front-icon-button
          status="primary"
          icon="arrow-paginator"
          class="arrow arrow-left"
          (click)="previousYear()"
          [disabled]="
            !!minDate && dateAdapter.getYear(minDateMoment) >= activeYear
          "
        >
        </wm-front-icon-button>
        <wm-front-icon-button
          status="primary"
          icon="arrow-paginator"
          class="arrow arrow-right"
          (click)="nextYear()"
          [disabled]="
            !!maxDate && dateAdapter.getYear(maxDateMoment) <= activeYear
          "
        >
        </wm-front-icon-button>
      </div>
    </div>
    @if (showMinRangeError) {
    <div class="calendar-error">
      <p
        i18n="
          Label | label for the error when the minimum month range is not
          respected@monthRangePickerminRangeErrorLabel
        "
      >
        Veulliez sélectionner au minimum {{ minRange }} mois
      </p>
    </div>
    }

    <div class="calendar-content">
      <table class="calendar-table" role="grid">
        <thead aria-hidden="true" class="calendar-table-header">
          <tr>
            <th class="calendar-table-header-divider" colspan="4"></th>
          </tr>
        </thead>
        <tbody
          mat-calendar-body
          [rows]="months"
          [labelMinRequiredCells]="2"
          [numCols]="4"
          [cellAspectRatio]="4 / 7"
          [activeCell]="dateAdapter.getMonth(activeDate)"
          [startValue]="getValueFromDate(selectedRangeValue.start) || 0"
          [endValue]="getValueFromDate(selectedRangeValue.end) || 0"
          [previewStart]="getValueFromDate(previewStart)"
          [previewEnd]="getValueFromDate(previewEnd)"
          [isRange]="true"
          (selectedValueChange)="selectedChange($event)"
          (previewChange)="previewChanged($event)"
        ></tbody>
      </table>
    </div>
  </div>

  <div
    class="reset"
    [class.resetMode]="selectedRangeValue.start && activeResetBtn"
    [class.disabled]="
      !selectedRangeValue.start && !selectedRangeValue.end && !activeResetBtn
    "
    (click)="resetPeriod()"
  >
    <p
      i18n="
        Button label | label for the reset button in the month range picker
        component@monthRangePickerResetActionButton
      "
    >
      Réinitialiser
    </p>
  </div>
</div>
